<template></template>
<script>
export default {
  data() {
    return {
      lockReconnect: false,
      timeout: 60000,//1分钟发一次心跳
      timeoutObj: null,
      serverTimeoutObj: null,
    }
  },

  mounted() {
    console.log("createWebSocket")
    this.createWebSocket()
  },
  beforeDestroy() {
    this.$store.state.messageSocket && this.$store.state.messageSocket.close();
    clearTimeout(self.timeoutObj);
    clearTimeout(self.serverTimeoutObj);
  },
  methods: {
    websocketOpen() {
      //打开
      this.heartStart()
    },
    websocketOnmessage(msg) {
      this.heartStart();

      if (!msg.data) return;
      this.$store.commit('socketMessage', { data: msg.data });
    },
    websocketClose() {
      //关闭
      this.reconnect();
    },
    websocketError(err) {
      //失败
      console.log(err, "WebSocket连接失败，请检查服务是否正常或刷新重试");
      this.reconnect();
    },
    createWebSocket() {
      try {
        if ('WebSocket' in window) {
          this.$store.dispatch('connectSocket')
          this.$store.state.messageSocket.onopen = this.websocketOpen;

          this.$store.state.messageSocket.onmessage = this.websocketOnmessage;
          this.$store.state.messageSocket.onclose = this.websocketClose;
          this.$store.state.messageSocket.onerror = this.websocketError;
        }
      } catch (e) {
        this.reconnect();
      }
    },
    reconnect() {
      // 连接失败会重新连
      if (this.lockReconnect) return;
      this.lockReconnect = true;
      if (this.$store.state.clientToken && this.$store.state.user.id) {
        setTimeout(() => {
          this.createWebSocket();
          this.lockReconnect = false;
        }, 3000);
      }
    },
    heartStart() {
      const self = this;
      clearTimeout(self.timeoutObj);
      clearTimeout(self.serverTimeoutObj);
      if(!self.$store.state.messageSocket) return
      self.$store.state.messageSocket.send("ping");//重置后就先发送一次，避免与下次间隔超过一分钟
      self.timeoutObj = setInterval(() => {
        self.$store.state.messageSocket.send("ping");
      }, self.timeout)
    }
  }
}
</script>
